<template>
  <div class="microwish-page">
    <SubPageHeader title="微心愿" />
    
    <div class="tabs">
      <div 
        class="tab-item" 
        :class="{ 'active': currentTab === 'all' }"
        @click="currentTab = 'all'"
      >
        <span>全部</span>
        <div class="line" v-if="currentTab === 'all'"></div>
      </div>
      <div 
        class="tab-item" 
        :class="{ 'active': currentTab === 'unclaimed' }"
        @click="currentTab = 'unclaimed'"
      >
        <span>未领取</span>
        <div class="line" v-if="currentTab === 'unclaimed'"></div>
      </div>
      <div 
        class="tab-item" 
        :class="{ 'active': currentTab === 'claimed' }"
        @click="currentTab = 'claimed'"
      >
        <span>已领取</span>
        <div class="line" v-if="currentTab === 'claimed'"></div>
      </div>
      <div 
        class="tab-item" 
        :class="{ 'active': currentTab === 'expired' }"
        @click="currentTab = 'expired'"
      >
        <span>已过期</span>
        <div class="line" v-if="currentTab === 'expired'"></div>
      </div>
    </div>

    <div class="list" v-if="wishList && wishList.length > 0">
      <div 
        v-for="(item, index) in wishList" 
        :key="item.id || index" 
        class="wish-card"
        :class="getCardTheme(index)"
        @click="goToDetail(item)"
      >
        <div class="title">“{{ item.content }}”</div>
        <div class="name">{{ item.uidName }}</div>
        <div class="date">{{ formatDate(item.createdAt) }}</div>
        <div class="claim-btn" v-if="item.wishStat === 0">领取</div>
        <div class="claim-btn" v-else-if="item.wishStat === 1" style="color: #999">已领取</div>
        <div class="claim-btn" v-else-if="item.wishStat === 2" style="color: #999">已过期</div>
        <div class="claim-btn" v-else>领取</div>
      </div>
    </div>
    <div v-else-if="!isLoading" class="empty-text">
      暂无微心愿数据
    </div>
  </div>
</template>

<script>
import SubPageHeader from '../component/SubPageHeader.vue';
import { getWishList } from '@/api';

export default {
  name: 'MicroWishPage',
  components: {
    SubPageHeader
  },
  data() {
    return {
      currentTab: 'all',
      wishList: [],
      page: 1,
      pageSize: 20,
      total: 0,
      isLoading: false
    };
  },
  watch: {
    currentTab() {
      this.page = 1;
      this.fetchWishList();
    }
  },
  mounted() {
    this.fetchWishList();
  },
  methods: {
    async fetchWishList() {
      if (this.isLoading) return;
      this.isLoading = true;
      
      try {
        let wishStat = undefined;
        if (this.currentTab === 'unclaimed') wishStat = 0;
        if (this.currentTab === 'claimed') wishStat = 1;
        if (this.currentTab === 'expired') wishStat = 2;

        const res = await getWishList({
          page: this.page,
          pageSize: this.pageSize,
          wishStat
        });
        
        if (res && res.data) {
          if (this.page === 1) {
            this.wishList = res.data.list || [];
          } else {
            this.wishList = this.wishList.concat(res.data.list || []);
          }
          this.total = res.data.total || 0;
        }
      } catch (error) {
        console.error('Failed to fetch wish list:', error);
      } finally {
        this.isLoading = false;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      // Only show YYYY-MM-DD
      return dateStr.split(' ')[0];
    },
    getCardTheme(index) {
      const themes = ['theme-cyan', 'theme-orange', 'theme-pink', 'theme-purple', 'theme-blue'];
      return themes[index % themes.length];
    },
    goToDetail(item) {
      if (item && item.id) {
        this.$router.push(`/organize/microwish/detail?id=${item.id}`);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.microwish-page {
  min-height: 100vh;
  background: #ffffff;
}

.tabs {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 12vw;
  border-bottom: 0.2vw solid #f5f5f5;
  margin-bottom: 4vw;
  padding: 0 4vw;
}

.tab-item {
  position: relative;
  font-size: 3.8vw;
  color: #999999;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  &.active {
    color: #e60012;
    font-weight: bold;
  }
  
  .line {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 6vw;
    height: 0.8vw;
    background-color: #e60012;
    border-radius: 0.4vw;
  }
}

.list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 3.5vw;
  padding: 0 4vw 6vw;
}

.empty-text {
  text-align: center;
  color: #999;
  padding: 10vw 0;
  font-size: 3.8vw;
}

.wish-card {
  position: relative;
  border-radius: 2vw;
  padding: 4vw;
  display: flex;
  flex-direction: column;
  height: 42vw;
  box-sizing: border-box;
  min-width: 0;
  
  .title {
    font-size: 3.8vw;
    font-weight: 500;
    margin-bottom: 3vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  
  .name {
    font-size: 3.2vw;
    margin-bottom: 2vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  
  .date {
    font-size: 2.6vw;
    margin-bottom: 6vw;
  }
  
  .claim-btn {
    position: absolute;
    bottom: 3vw;
    right: 3vw;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 4vw;
    padding: 1vw 4vw;
    font-size: 3.2vw;
    font-weight: 500;
  }
}

/* Themes */
.theme-cyan {
  background-color: #d1fae5;
  color: #10b981;
  .claim-btn { color: #10b981; }
}

.theme-orange {
  background-color: #ffedd5;
  color: #f97316;
  .claim-btn { color: #f97316; }
}

.theme-pink {
  background-color: #ffe4e6;
  color: #f43f5e;
  .claim-btn { color: #f43f5e; }
}

.theme-purple {
  background-color: #f3e8ff;
  color: #a855f7;
  .claim-btn { color: #a855f7; }
}

.theme-blue {
  background-color: #dbeafe;
  color: #3b82f6;
  .claim-btn { color: #3b82f6; }
}
</style>
